export * from './lib/get-app-variable';
